import { Product } from '../types';

export const CUSTOM_AMOUNT_PLACEHOLDER = 1;

export function isCustomAmountProduct(product?: Pick<Product, 'category'> | null): boolean {
  return product?.category === 'Support';
}

export function getCustomAmounts(): Record<string, string> {
  const stored = localStorage.getItem('customAmounts');
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return {};
    }
  }

  const legacyTip = localStorage.getItem('customTipAmount');
  if (legacyTip) {
    return { '8': legacyTip };
  }

  return {};
}

export function getCustomAmount(productId: string): string {
  return getCustomAmounts()[productId] || '';
}

export function setCustomAmount(productId: string, amount: string): void {
  const amounts = getCustomAmounts();
  amounts[productId] = amount;
  localStorage.setItem('customAmounts', JSON.stringify(amounts));
}

export function getCustomAmountNumber(productId: string): number {
  return parseFloat(getCustomAmount(productId)) || 0;
}

export function getCustomAmountPlaceholderDeduction(
  items: Array<{ productId: string; quantity: number; product?: Product }>
): number {
  return items.reduce((deduction, item) => {
    if (!isCustomAmountProduct(item.product)) return deduction;
    return deduction + CUSTOM_AMOUNT_PLACEHOLDER * item.quantity;
  }, 0);
}

export function getCustomAmountTotal(
  items: Array<{ productId: string; quantity: number; product?: Product }>
): number {
  return items.reduce((total, item) => {
    if (!isCustomAmountProduct(item.product)) return total;
    return total + getCustomAmountNumber(item.productId) * item.quantity;
  }, 0);
}

export function getCustomAmountsPayload(
  items: Array<{ productId: string; product?: Product }>
): Record<string, number> {
  const payload: Record<string, number> = {};

  for (const item of items) {
    if (!isCustomAmountProduct(item.product)) continue;
    const amount = getCustomAmountNumber(item.productId);
    if (amount >= 1) {
      payload[item.productId] = amount;
    }
  }

  return payload;
}
